import type React from 'react';

import { useAppSelector } from 'hooks/reduxHooks';
import { selectTrackingInfo } from 'store/reducers/stream-tracker/selectors';
import { AgentStreamProvider } from './context/AgentStreamContext';
import { useRouteParams } from './hooks';

interface AgentStreamProps {
  children?: React.ReactNode;
  hideLoader?: boolean;
}

export const AgentStream = ({ children, hideLoader }: AgentStreamProps) => {
  const { accountId, projectId } = useRouteParams();
  const { branchId } = useAppSelector(selectTrackingInfo);

  return (
    <AgentStreamProvider
      accountId={accountId}
      branchId={branchId}
      hideLoader={hideLoader}
      projectId={projectId}
    >
      {children}
    </AgentStreamProvider>
  );
};
